import React, { useState } from "react";
import "./Contact.css";
import { motion } from "framer-motion";
import {
  FaPaperPlane,
  FaCheckCircle,
  FaExclamationCircle,
} from "react-icons/fa";
import { useLanguage } from "../../context/LanguageContext"; // Import

const Contact = () => {
  const { t } = useLanguage(); // Hooks traduction
  const [formData, setFormData] = useState({
    nom: "",
    prenom: "",
    entreprise: "",
    email: "",
    message: "",
  });

  const [status, setStatus] = useState("idle");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");

    try {
      const response = await fetch("/api/send", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus("success");
        setFormData({
          nom: "",
          prenom: "",
          entreprise: "",
          email: "",
          message: "",
        });
      } else {
        setStatus("error");
      }
    } catch (error) {
      console.error(error);
      setStatus("error");
    }
  };

  return (
    <section className="contact-section" id="contact">
      <div className="contact-container">
        <div className="contact-header">
          <h2>
            {t.contact.title}{" "}
            <span className="text-gold">{t.contact.titleSpan}</span>
          </h2>
          <div className="section-line"></div>
          <p>{t.contact.subtitle}</p>
        </div>

        <motion.div
          className="form-wrapper"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          {status === "success" ? (
            <div className="success-message">
              <FaCheckCircle className="success-icon" />
              <h3>{t.contact.success.title}</h3>
              <p>
                {/* On insère le prénom au milieu des textes traduits */}
                {t.contact.success.thankYou} {formData.prenom},{" "}
                {t.contact.success.teamResponse}
              </p>
              <button onClick={() => setStatus("idle")} className="btn-reset">
                {t.contact.success.reset}
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-row">
                <div className="input-group">
                  <label>{t.contact.form.nom}</label>
                  <input
                    type="text"
                    name="nom"
                    required
                    value={formData.nom}
                    onChange={handleChange}
                    placeholder={t.contact.form.placeholders.nom}
                  />
                </div>
                <div className="input-group">
                  <label>{t.contact.form.prenom}</label>
                  <input
                    type="text"
                    name="prenom"
                    required
                    value={formData.prenom}
                    onChange={handleChange}
                    placeholder={t.contact.form.placeholders.prenom}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="input-group">
                  <label>{t.contact.form.entreprise}</label>
                  <input
                    type="text"
                    name="entreprise"
                    required
                    value={formData.entreprise}
                    onChange={handleChange}
                    placeholder={t.contact.form.placeholders.entreprise}
                  />
                </div>
                <div className="input-group">
                  <label>{t.contact.form.email}</label>
                  <input
                    type="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    placeholder={t.contact.form.placeholders.email}
                  />
                </div>
              </div>

              <div className="input-group">
                <label>{t.contact.form.message}</label>
                <textarea
                  name="message"
                  required
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder={t.contact.form.placeholders.message}
                ></textarea>
              </div>

              <button
                type="submit"
                className="btn-submit"
                disabled={status === "loading"}
              >
                {status === "loading" ? (
                  t.contact.form.sending
                ) : (
                  <>
                    {t.contact.form.submit} <FaPaperPlane />
                  </>
                )}
              </button>

              {status === "error" && (
                <p className="error-msg">
                  <FaExclamationCircle /> {t.contact.error}
                </p>
              )}
            </form>
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;
